import { FC, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaRegBell } from "react-icons/fa6";
import { deviceInfoContext } from "../../../context";
import logo from "../../../assets/images/mandi-logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../store";
import { PanelSlider } from "../../../components/ui";
import cancelIcon from "../../../assets/images/close.svg";
import Notifications from "./Notifications";
import "./notifi.scss";
import usePayNotifications from "../../../hooks/usePaymentNotifications";
import UserAvatar from "../../components-library/userAvatar";
import {
  setNotification,
  setNotifiTabs,
} from "../../../reducers/trade_details_Slice";
import { setActiveCategoryTab } from "../../../reducers/riskEngineSlice";
import { PARTNER } from "../../../constants/partners";
const PageHeader: FC<{
  title?: string;
  showBackButton?: boolean;
  showTitle?: boolean;
  showUserInfo?: boolean;
  topVal?: string;
  fromScreen?: string;
  subText?: string;
  imgsrc?: string;
}> = ({
  title,
  showBackButton,
  showTitle,
  showUserInfo,
  topVal,
  fromScreen,
  subText,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { width } = useContext(deviceInfoContext);

  const { loggedin, notification, adminId, userName, loginType } = useSelector(
    (state: TRootState) => ({
      loggedin: state.auth.loggedin,
      notification: state.tradeDetails.notification,
      adminId: state.auth.adminId,
      userName: state.auth.userInfo?.name,
      loginType: state.auth.userInfo?.type,
    }),
  );
  const back = () => {
    if (
      showTitle === true &&
      (fromScreen == "View Trade" || fromScreen == "Customer Details")
    ) {
      navigate("/");
      sessionStorage.removeItem("persistedData");
    } else {
      navigate(-1);
      if (location.pathname.startsWith("/risk-engine/composition")) {
        dispatch(setActiveCategoryTab("FIN"));
      }
    }
  };
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [key, setKey] = useState(0);

  const handleClick = () => {
    setKey((prevKey) => prevKey + 1);
  };

  const { notifications, getNotifications } = usePayNotifications({});

  const panelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(event.target as Node)
      ) {
        dispatch(setNotification(false));
      }
    };
    if (notification) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notification]);

  const delayNotifications = () => {
    setTimeout(() => {
      dispatch(setNotification(true));
    }, 500);
  };

  return (
    <>
      <div
        className="bg-white flex items-center p-[20px] font-semibold w-full sticky z-[999] md:static md:z-auto border-b"
        style={{ height: "3.8rem", top: topVal }}
      >
        {showBackButton === true && (
          <div
            className="pr-3 pl-2 cursor-pointer h-full flex"
            onClick={() => {
              back();
            }}
          >
            <FaArrowLeft className="mt-auto mb-auto" />
          </div>
        )}
        {showTitle === true && (
          <div className=" flex flex-col w-full">
            <span className="text-xl font-semibold">{title}</span>
          </div>
        )}
        {showUserInfo === true && (
          <div className="flex justify-end items-center w-full">
            {loginType === PARTNER.ONO && (
              <div
                className="relative px-2 cursor-pointer"
                onClick={() => {
                  handleClick();
                  delayNotifications();
                  getNotifications();
                  dispatch(setNotifiTabs("trades"));
                }}
              >
                <div key={key} className="animate-shake border br-100 p-2">
                  <FaRegBell className="color-primary w-5 h-5" />
                </div>
                {notifications?.length > 0 && (
                  <span
                    className="absolute top-0 right-0 w-4 h-4 bg-orange-600 rounded-full flex justify-center items-center"
                    style={{ top: "-6px", padding: "12px", right: "4px" }}
                  >
                    <span className="text-xs text-white font-size">
                      {notifications?.length}
                    </span>
                  </span>
                )}
              </div>
            )}
            <div
              className="flex gap-2 cursor-pointer items-center ml-4"
              onClick={() => {
                navigate("/my-profile");
              }}
            >
              {/* <img src={DefultLogo} className="w-8 h-8" />
               */}
              <UserAvatar name={userName} />
              <div className="flex flex-col text-sm">
                <span className="font-semibold">{userName}</span>
                <span className="hidden md:block color-sub-text">{`ADMIN ID: ${adminId}`}</span>
              </div>
            </div>
          </div>
        )}
        {loggedin === false && (
          <span className="flex ml-auto gap-2">
            <img src={logo} className="ml-auto w-16 px-1" alt="" />
          </span>
        )}
      </div>

      <div>
        <PanelSlider
          direction={isMobile ? "bottom_to_top" : "right_to_left"}
          open={notification}
          onClose={() => {
            dispatch(setNotification(false));
          }}
          style={{ width: isMobile ? "100%" : "40vw" }}
        >
          <div
            ref={panelRef}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="py-4 px-4 border-b flex items-center justify-between">
              <div>
                <h2 className="text-base font-semibold">Notifications</h2>
              </div>
              <div>
                <img
                  src={cancelIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(setNotification(false));
                  }}
                />
              </div>
            </div>
            <div className="px-4 py-4">
              <Notifications />
            </div>
          </div>
        </PanelSlider>
      </div>
    </>
  );
};
export default PageHeader;
